import { useRef } from 'react';
import { useQuery } from '@tanstack/react-query';
import { queryKey } from '../../../constants/queryKey';
import { searchService } from 'shared/src/api';
import type { SuggestKeywordResponse } from 'shared/src/api/searchService/types';

export const useSuggestKeywords = (query: string) => {
  const result = useQuery({
    queryKey: queryKey.suggestKeywords(query),
    queryFn: () => searchService.getSuggestKeywords(query),
    enabled: query.trim().length > 0,
    staleTime: 1000 * 10,
    placeholderData: prev => prev,
  });

  // 빈 결과가 아닌 마지막 데이터를 유지 (iOS: fetchSuggestedItems에서 빈 결과 시 state 미갱신)
  const lastNonEmptyData = useRef<SuggestKeywordResponse | undefined>(
    undefined,
  );

  // 검색어가 비면 ref 초기화 (다른 검색어 입력 시 이전 결과 노출 방지)
  if (query.trim().length === 0) {
    lastNonEmptyData.current = undefined;
  } else if (
    result.data &&
    (result.data.linked_suggesters.length > 0 ||
      result.data.query_suggesters.length > 0)
  ) {
    lastNonEmptyData.current = result.data;
  }

  return { data: lastNonEmptyData.current ?? result.data };
};
